import { alpha, Avatar, Box, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

interface SpecificOfferCardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    descriptionComponent?: React.ReactElement;
}

const SpecificOfferCard: React.FC<SpecificOfferCardProps> = ({ icon, title, description, descriptionComponent }) => {
    const [expanded, setExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = textRef.current;
        if (el) {
            const lineHeight = parseFloat(getComputedStyle(el).lineHeight || '20');
            const maxHeight = lineHeight * 2; // 2 linije
            if (el.scrollHeight > maxHeight) {
                setShowButton(true);
            }
        }
    }, []);

    return (
        <Box
            sx={(theme) => ({
                position: "relative",
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                p: 3,
                px: 2,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.background.default, 0.2),
                border: '2px solid #ffffff39',
                backdropFilter: 'blur(16px)',
                transition: '0.3s',
                height: '100%',
                ...theme.applyStyles('dark', {
                    bgcolor: alpha(theme.palette.background.default, 0.5),
                    border: '2px solid #ffffff31',
                }),
                [theme.breakpoints.up("md")]: {
                    "&:hover": {
                        transform: "scale(1.05)",
                    },
                },
            })}
        >
            <Avatar
                sx={{
                    bgcolor: 'success.main',
                    width: 64,
                    height: 64,
                    mb: 1,
                }}
            >
                {icon}
            </Avatar>

            <Typography variant="h6" gutterBottom>
                {title}
            </Typography>

            <Typography
                ref={textRef}
                variant="body2"
                color="text2.primary"
                textAlign={"start"}
                sx={{
                    whiteSpace: 'pre-line',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: expanded ? 'none' : 2,
                    WebkitBoxOrient: 'vertical',
                    textOverflow: 'ellipsis',
                }}
            >
                {description}
            </Typography>

            {showButton && (
                <Typography
                    onClick={() => setExpanded((prev) => !prev)}
                    sx={{
                        position: "absolute",
                        bottom: 4,
                        right: 16,
                        textDecoration: "underline",
                        cursor: "pointer"
                    }}
                    variant='caption'>
                    {expanded ? 'Prikaži manje' : 'Prikaži više'}
                </Typography>
            )}

            {descriptionComponent && descriptionComponent}
        </Box>
    );
};

export default SpecificOfferCard;
